// @flow
import React, { PureComponent } from 'react';
import BodyClassName from './BodyClassName';
import FixedPage from './FixedPage';

export const SCRIM = { backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 9 };

export default class Overlay extends PureComponent {
  render() {
    const { children, className, style, ...rest } = this.props;
    return (
      <BodyClassName className="overflow-hidden">
        <FixedPage className={className} style={{ ...SCRIM, ...style }} {...rest}>
          {children}
        </FixedPage>
      </BodyClassName>
    );
  }
}